module.exports = __webpack_public_path__ + "static/media/part-detail-slide-1.a7116777.jpg";